export default __webpack_public_path__ + "static/media/logo1.5878a3cb.png";